'use es6';

import Client from 'AdsUI/data/Client';
const APP_USERS_BASE = 'app-users/v1';
export default {
  getUsers() {
    return Client.apiRequest(`${APP_USERS_BASE}/users`);
  },

  getTeams() {
    return Client.apiRequest(`${APP_USERS_BASE}/teams/hierarchy`);
  }

};